import React, {Component} from "react";
import {connect} from 'react-redux'
import FJResourcesSearchCommon from "../view/FJResourcesSearchCommon";
import FJConfig from "../../../config/FJConfig";
import FJLocalStore from "../../../store/FJLocalStore";
import styles from "../view/css/FJResourceElementContainer.module.less";
import FJElementStore from "../../../store/FJElementStore";
import FJCoreConstant from "../../../core/constant/FJCoreConstant";
import {FJMediaAction} from "../../../redux/action/FJRoot.action";
import $ from "jquery";
import FJSearchList from "../view/FJSearchList";
import FJViewConstant from "../../../constant/FJViewConstant";
import ElementSVG from "../../../icon/element-timeline.svg";
import FJUtil from "../../../util/FJUtil";
import FJResourcesElementList from "../view/FJResourcesElementList";
import FJResourceElementMore from "../view/FJResourceElementMore";
import FJPanelAnimation from "../../../common/component/FJPanelAnimation/FJPanelAnimation";

class FJResourcesElementContainer extends Component {

  constructor(props) {
    super(props);
    this._classes = {
      textListClasses: {
        textListBox: ''
      },
      textMoreClasses: {
        textMoreBox: ''
      },
      pageHeaderClasses: {
        listBox: styles.page_header_list_box,
        seeAllBox: styles.more_animation_box,
        titleBox: styles.text_animation_box,
        moreBox: styles.more_box,
      },
      pageHeaderBackClasses: {
        headerBox: styles.more_header_text,
        backBox: styles.back_more_back,
        titleBox: styles.more_title,
        backTextBox: styles.more_desc
      },
      itemClasses: {
        resourceItem: styles.item,
        resourceItemActive: styles.item_active,
        inner: styles.inner_box,
        addBtnBox: styles.add_box,
        deleteBtnBox: '',
        addBtn: styles.add_button,
        name: '',
        link: '',
        refresh: '',
        reloadIcon: ''
      },
      scrollClasses: {
        trackVertical: '',
        trackHorizontal: '',
        thumbVertical: '', // styles.media_thumbVertical
        thumbHorizontal: '',
      },
    };
    this._config = {
      addIconToolTip: FJLocalStore._('add-to-timeline')
    };
    this._resourceViewInfo = {
      width: 90,
      height: 90,
      space: 16,
      marginBottom: 20,
    };
    this._resourceMoreViewInfo = {
      width: 80,
      height: 80,
      space: 30,
      marginBottom: 20,
    };
    this._resourceSearchViewInfo = {
      width: 80,
      height: 80,
      space: 9,
      marginBottom: 9,
    };
    this._maxCount = 0;
    this.state = {
      resourcesElementList: [],
      showType: 1, // 1 代表列表 2 代表分类详情列表 3 搜索列表
      searchResult: [],
      fetchLoading: false,
      keyword: '',
      jumpScroll: false,
      useElementData: {},
    };
  }

  componentDidMount() {
    this._asyncDealTextData();
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    return !this.props
      || this.props.chooseMediaIdList !== nextProps.chooseMediaIdList
      || this.props.direction !== nextProps.direction
      || this.props.isShow !== nextProps.isShow
      || this.state !== nextState
  }

  _allTooltip = () => {
    FJUtil.allTooltip('u-tooltip-bottom', 'bottom');
  };

  _oneTooltip = (ele) => {
    FJUtil.oneTooltip(ele, 'bottom');
  };

  /**
   * @description 返回Text列表
   * @private
   */
  _backElement = () => {
    this.setState({
      showType: 1
    })
  };

  /**
   * @description 显示搜索列表
   * @private
   */
  _seeSearchList = () => {
    this.setState({
      showType: 3
    })
  }

  /**
   * 点击展开分类全部
   * @param id
   * @param title
   * @private
   */
  _elementSeeMore = (id, title) => {
    let list = this.state.useElementData[id];
    this.setState({
      resourcesElementList: list,
      title,
      showType: 2,
      keyword: ''
    });
  };

  _asyncDealTextData = () => {
    let tempData = FJElementStore.getList() && FJElementStore.getList().data;
    if (tempData) {
      let perCount = 4;
      let curCount = perCount;
      this._maxCount = tempData.length;
      let func = (count) => {
        this.setState({useElementData: this._dealTextData(tempData, count)}, () => {
          if (count < this._maxCount) {
            setTimeout(() => {
              func(count + perCount);
            }, 150)
          }
        });
      };

      func(curCount);
    }
  };

  /**
   * 处理 Element 数据
   * @returns {{}}
   * @private
   */
  _dealTextData = (tempData, count) => {
    let obj = {};
    (tempData || []).slice(0, count).forEach((temp) => {
      let {category, list} = temp;
      obj[FJLocalStore._(category)] = list.map(item => {
        return this._wrapItem(item, category);
      })
    });
    return obj;
  };

  _wrapWebItem = (item) => {
    return {
      ...item,
      thumbnail: item.imageURL,
      type: FJCoreConstant.SVG,
      fromType: FJViewConstant.SVG_WEB,
    }
  };

  _wrapItem = (item) => {
    let {elementIconPath, elementVideoPath, staticSvgPath, version,} = FJConfig;
    let {WIDGET, MULTI_WIDGET, SVG} = FJCoreConstant;
    let {name, localName, tag, previewFormat, type, author} = item;
    let category = FJElementStore.getCategoryByName(name, type);
    let _type = type && type.toLowerCase();
    let thumbnail;
    let authorItem = {};
    if (_type === WIDGET.toLowerCase() || _type === MULTI_WIDGET.toLowerCase()) {
      thumbnail = `${elementIconPath}${name.replace(/\\s+/g, '_')}.${previewFormat || 'svg'}?v=${version}`;
    } else {
      thumbnail = `${staticSvgPath}${category}/${name.replace(/\\s+/g, '_')}.svg?v=${version}`;
    }

    if (author) {
      authorItem = {
        author: item.author,
        lottieUrl: item.lottieUrl,
        localName: item.localName
      };
    }

    let data = {
      title: FJLocalStore._(localName),
      url: type ? `${elementVideoPath}${name.replace(/\\s+/g, '_')}.mp4?v=${version}` : '',
      thumbnail,
      tag,
      id: name,
      type: type ? type.toUpperCase() : SVG,
      authorItem: authorItem
    };

    if (data.type === SVG) {
      data.fromType = FJViewConstant.SVG_LOCAL;
    }

    return data;
  };

  /**
   * @description 拖动资源库文件
   * @param e
   * @param data
   * @param callback
   * @private
   */
  _onMediaDrag = (e, data, callback) => {
    this.props.onMediaDrag(e, data, callback, this._getDragNodeInTimeLine, {height: 26});
  };

  /**
   * @description 得到拖动background到时间轴的样式
   * @param selfRect
   * @returns {HTMLDivElement}
   * @private
   */
  _getDragNodeInTimeLine = (selfRect) => {
    let node = document.createElement('div');
    let child = document.createElement('div');
    let img = document.createElement('div');

    $(img).append(ElementSVG);
    $(child).append(img);
    $(node).append(child);

    $(child).addClass(styles.img_child_box);
    $(node).addClass(styles.active);
    $(node).addClass(styles.drag_other_img);
    let backgroundColor = '#AB57FB';
    let backgroundImage = 'none';
    $(node).css({
      width: selfRect.width,
      height: selfRect.height,
      backgroundColor: backgroundColor,
      backgroundPosition: 'auto',
      backgroundImage: backgroundImage,
      borderColor: 'rgba(171, 87, 251, 1)',
      borderRadius: '4px'
    });
    return node;
  };

  resetJumpScroll = () => {
    this.setState({
      jumpScroll: false
    })
  }

  /**
   * @description 开始搜索widget
   * @param keyword
   * @private
   */
  _searchWidget = (keyword) => {
    this._seeSearchList();
    this.lastSearchID = Date.now();
    let searchID = this.lastSearchID;
    let lowerkeyword = keyword.toLowerCase();
    this.setState({
      fetchLoading: true
    });
    let updateSearchHistory = () => {
      if (this.state.searchResult.length > 0) {
        FJElementStore.addSearchHistory(lowerkeyword);
      }
    };
    FJElementStore.searchFromWeb(FJUtil.filterStr(lowerkeyword)).then(data => {
      if (this.lastSearchID !== searchID) {
        return;
      }
      this.setState({
        searchResult: [
          ...FJElementStore.searchByTag(lowerkeyword).map(this._wrapItem),
          ...data.map(this._wrapWebItem),
        ],
        keyword: keyword,
      }, updateSearchHistory);
    }).finally(() => {
      if (this.lastSearchID === searchID) {
        this.setState({fetchLoading: false});
      }
    });

    this.setState({
      searchResult: FJElementStore.searchByTag(keyword).map(this._wrapItem),
      keyword: keyword
    }, updateSearchHistory);
  }

  _nextPage = (scroll, location) => {
    this.lastSearchID = Date.now();
    let searchID = this.lastSearchID;
    this.setState({
      fetchLoading: true
    });
    FJElementStore.nextPage().then(data => {
      if (this.lastSearchID !== searchID) {
        return;
      }
      let oldData = this.state.searchResult;
      this.setState({
        searchResult: [
          ...oldData,
          ...data.map(this._wrapWebItem),
        ],
        jumpScroll: true
      }, () => {
        scroll.scrollTop(location, true);
      });
    }).finally(() => {
      if (this.lastSearchID === searchID) {
        this.setState({fetchLoading: false});
      }
    });
  };

  _render = (hasInit) => {
    const placeholder = FJLocalStore._('search input');
    let {
      showType,
      resourcesElementList,
      title,
      searchResult,
      keyword,
      fetchLoading,
      jumpScroll
    } = this.state;
    let {onAddClick, onHandleClick, chooseMediaIdList,} = this.props;
    return (
      <>
        <FJResourcesSearchCommon style={{display: (showType === 1 || showType === 3) ? 'flex' : 'none'}}
                                 searchResult={this._searchWidget}
                                 backElement={this._backElement}
                                 placeholder={placeholder}
        />
        <FJSearchList isShow={showType === 3}
                      list={searchResult}
                      classes={this._classes}
                      resourceViewInfo={this._resourceSearchViewInfo}
                      chooseMediaIdList={chooseMediaIdList}
                      config={this._config}
                      onAddClick={onAddClick}
                      onHandleClick={onHandleClick}
                      keyword={keyword}
                      fetchLoading={fetchLoading}
                      allTooltip={this._allTooltip}
                      oneTooltip={this._oneTooltip}
                      onMediaDrag={this._onMediaDrag}
                      nextPage={this._nextPage}
                      searchWidget={this._searchWidget}
                      jumpScroll={jumpScroll}
                      resetJumpScroll={this.resetJumpScroll}
        />
        <FJResourcesElementList isShow={showType === 1}
                                hasInit={hasInit}
                                allResourcesElement={this.state.useElementData}
                                resourceViewInfo={this._resourceViewInfo}
                                seeAllText={FJLocalStore._('see-all')}
                                config={this._config}
                                classes={this._classes}
                                onAddClick={onAddClick}
                                onHandleClick={onHandleClick}
                                onMediaDrag={this._onMediaDrag}
                                seeMore={this._elementSeeMore}
                                chooseMediaIdList={chooseMediaIdList}
                                allTooltip={this._allTooltip}
                                oneTooltip={this._oneTooltip}
        />
        <FJResourceElementMore isShow={showType === 2}
                               classes={this._classes}
                               resourceViewInfo={this._resourceMoreViewInfo}
                               backTitle={FJLocalStore._('back')}
                               config={this._config}
                               list={resourcesElementList}
                               backElement={this._backElement}
                               title={FJLocalStore._(title)}
                               chooseMediaIdList={chooseMediaIdList}
                               onAddClick={onAddClick}
                               onHandleClick={onHandleClick}
                               onMediaDrag={this._onMediaDrag}
                               allTooltip={this._allTooltip}
                               oneTooltip={this._oneTooltip}

        />
      </>
    );
  };

  render() {
    let {isShow, direction,} = this.props
    return (
      <FJPanelAnimation active={isShow} direction={direction} render={this._render}/>
    )
  }
}

const mapStateToProps = function (state) {
  return {
    chooseMediaIdList: state.media.chooseMediaIdList,
    direction: state.resource.direction,
  }
}

const mapDispatchToProps = function (dispatch) {
  return {
    onAddClick: function (id, type, fromType) {
      dispatch(FJMediaAction.addToTimeLineAction(type, fromType, id))
    },
    onHandleClick: function (id, type, rate) {
      dispatch(FJMediaAction.selectMediaAction(id, type, rate));
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FJResourcesElementContainer);
